import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApple = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 30,
	viewBox: "0 0 28 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2153_7674)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M24.5126 9.73796C24.3469 9.8665 21.4219 11.5147 21.4219 15.1797C21.4219 19.4188 25.1439 20.9185 25.2553 20.9556C25.2382 21.047 24.664 23.0095 23.2929 25.009C22.0703 26.7687 20.7934 28.5254 18.851 28.5254C16.9085 28.5254 16.4086 27.3971 14.1662 27.3971C11.981 27.3971 11.204 28.5626 9.42723 28.5626C7.65046 28.5626 6.41072 26.9343 4.9853 24.9348C3.33422 22.5867 2.00021 18.9389 2.00021 15.4768C2.00021 9.92363 5.61088 6.97853 9.16442 6.97853C11.0526 6.97853 12.6266 8.21828 13.812 8.21828C14.9404 8.21828 16.7 6.90426 18.8481 6.90426C19.6622 6.90426 22.5873 6.97853 24.5126 9.73796ZM17.8283 4.55333C18.7167 3.49927 19.3451 2.03672 19.3451 0.574165C19.3451 0.371351 19.328 0.165679 19.2909 0C17.8455 0.0542743 16.1258 0.962655 15.0889 2.16526C14.2748 3.09078 13.5149 4.55333 13.5149 6.03588C13.5149 6.25869 13.5521 6.4815 13.5692 6.55291C13.6606 6.57005 13.8092 6.59004 13.9577 6.59004C15.2546 6.59004 16.8857 5.72166 17.8283 4.55333Z",
			fill: "black"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2153_7674",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 23.2523,
			height: 28.5654,
			fill: "white",
			transform: "translate(2)"
		})
	}) })]
});
export default SvgApple;
